export const iconStyles = {
  pointerEvents: 'none',
  position: 'absolute',
  left: 18,
  top: 12,
  color: 'var(--color-main-orange)',
};
export const iconAcceptStyles = {
  ...iconStyles,
  color: 'var(--color-light-green)',
};

export const iconErrorStyles = {
  ...iconStyles,
  color: 'var(--color-red)',
};

